import { Form as RdrTransferFormComponent } from "./RdrTransfer.js";

export const RdrTransferForm = RdrTransferFormComponent;
